import React from 'react';
import PropTypes from 'prop-types';

const PricingHero = ({ tab, images }) => {
  const isMembership = tab === 1;

  return (
    <div className="pricing-hero">
      <div className="pricing-hero__stars" aria-hidden="true" />

      {isMembership ? (
        <>
          {images.premium && (
            <img
              src={images.premium}
              alt=""
              className="pricing-hero__decor pricing-hero__decor--crown"
              aria-hidden="true"
            />
          )}
          {images.user && (
            <>
              <img
                src={images.user}
                alt=""
                className="pricing-hero__decor pricing-hero__decor--avatar-1"
                aria-hidden="true"
              />
              <img
                src={images.user}
                alt=""
                className="pricing-hero__decor pricing-hero__decor--avatar-2"
                aria-hidden="true"
              />
            </>
          )}
        </>
      ) : (
        <>
          {images.lexicoin && (
            <>
              <img
                src={images.lexicoin}
                alt=""
                className="pricing-hero__decor pricing-hero__decor--coin-1"
                aria-hidden="true"
              />
              <img
                src={images.lexicoin}
                alt=""
                className="pricing-hero__decor pricing-hero__decor--coin-2"
                aria-hidden="true"
              />
              <img
                src={images.lexicoin}
                alt=""
                className="pricing-hero__decor pricing-hero__decor--coin-3"
                aria-hidden="true"
              />
            </>
          )}
        </>
      )}

      <div className="pricing-hero__content">
        <h1 className="pricing-hero__title">
          {isMembership ? 'Go Pro' : 'Lexicoins'}
        </h1>
        {isMembership ? (
          <>
            <p className="pricing-hero__tagline">
              Meet more learners. Learn faster. Support Lexody.
            </p>
            <p className="pricing-hero__subtitle">
              Unlock premium features and level up your language journey.
            </p>
          </>
        ) : (
          <p className="pricing-hero__subtitle">
            Use Lexicoins to unlock features and connect with more learners.
          </p>
        )}
      </div>
    </div>
  );
};

PricingHero.propTypes = {
  tab: PropTypes.number.isRequired,
  images: PropTypes.shape({
    premium: PropTypes.string,
    user: PropTypes.string,
    lexicoin: PropTypes.string,
  }),
};

PricingHero.defaultProps = {
  images: {},
};

export default PricingHero;
